export const HOUSING_FIELDS = [  
  { key: "number", label: "number" },
  { key: "postal_code", label: "postal_code" },
  { key: "city", label: "city" },
  { key: "rooms_number", label: "rooms_number", type: "number" },
  { key: "picture", label: "picture", type: "file" },
  { key: "isActive", label: "isActive", type: "checkbox" },
]

export const HOUSING_REQUIRED_FIELDS = [
  { key: "street_name", label: "street_name" },

];

export const FIELDS = [...HOUSING_REQUIRED_FIELDS, ...HOUSING_FIELDS]


export const INFO_FIELDS = [
  { key: "street_name", label: "Street Name" },
  { key: "number", label: "Number" },
  { key: "postal_code", label: "Postal Code" },
  { key: "city", label: "City" },
  { key: "rooms_number", label: "Rooms Number" },
  { key: "max_capacity", label: "Max People" },
  { key: "availability", label: "Available" },
];
